import { MouseEventHandler } from 'react';
import { Source } from '../../../constants/Source';
import { ActionClickOrigin } from '../../../utils/hooks/bi/useTrackActions/useTrackActions.types';
import { BoardItemsActionsBIParams } from '../../../utils/hooks/useBoards';
import { MediaManagerSDKAnyItem, MediaManagerSDKFile, MediaManagerSDKFolder } from '../../../utils/media-manager-sdk';

export enum ActionButton {
  CropAndEdit = 'cropAndEdit',
  Preview = 'preview',
  Purchase = 'purchase',
  More = 'more',
  AddToBoard = 'addToBoard',
}

export enum ActionButtonSkin {
  Dark = 'dark',
  Light = 'light',
}

export interface IOuter {
  item: MediaManagerSDKAnyItem;
  currentFolder: MediaManagerSDKFolder;
  buttons: ActionButton[];
  isPanel?: boolean;
  skin?: ActionButtonSkin;
  isSecure?: boolean;
  className?: string;
  innerClassName?: string;
  buttonClassName?: string;
  dataHook?: string;
  onBuyClick?: (item: MediaManagerSDKFile) => void;
  onThreeDotsClick?: MouseEventHandler;
  onOpenExpandedViewClick?: () => void;
  onRemoveItemsFromBoard?: (items: MediaManagerSDKAnyItem[], biParams: BoardItemsActionsBIParams) => void;
  source?: Source;
  actionsClickOrigin: ActionClickOrigin;
}

export interface IItemActionButtonOuter {
  skin?: ActionButtonSkin;
  className?: string;
  dataHook?: string;
  onClick: MouseEventHandler;
}
